<template>
  <div>
    <div class="content-i">
      <form v-on:submit.prevent="broadcastMessage()">
        <div class="content-box">
          <div class="row">
            <div class="col-12">
              <div class="element-wrapper">
                <h6 class="element-header">{{ t('messageBroadcastPageHeader', 'messageBroadcastPageHeader') }}</h6>
                <div class="row mx-0">
                  <div class="col-5 element-box mr-2">
                    <div class="col-12 form-group">
                      <div class="element-info pb-0">
                        <h5>{{ t('selectMessageText', 'selectMessageText') }}</h5>
                        <hr>
                        <div class="row form-group form-line">
                          <label for="messagePDF" class="col-sm-3 col-form-label">{{ t('messagePDFLabel', 'messagePDFLabel') }}</label>
                          <div class="col-sm-9 mb-2">
                            <b-form-file accept=".pdf" id="messagePDF" v-model="messagePDF"></b-form-file>
                            <small>{{ t('broadcastMsgFirstPageText', 'broadcastMsgFirstPageText') }}</small>
                          </div>
                          <label for="emailSubject" class="col-sm-3 col-form-label">{{ t('emailSubjectText', 'emailSubjectText') }}</label>
                          <div class="col-sm-9 mb-2">
                            <input type="text" class="form-control" id="emailSubject" placeholder="Email subject" v-model="emailSubject">
                          </div>
                          <label for="emailText" class="col-sm-3 col-form-label">{{ t('accompanyingEmailTextLabel', 'accompanyingEmailTextLabel') }}	</label>
                          <div class="col-sm-9 mb-2">
                            <b-form-textarea id="emailText" placeholder="Email text" rows="8" v-model="emailText"></b-form-textarea>
                            <small>{{ t('accompanyingEmailTextDesc', 'accompanyingEmailTextDesc') }}</small>
                          </div>
                          <label for="displayDate" class="col-sm-3 col-form-label">{{ t('displayDateLabel', 'displayDateLabel') }}</label>
                          <div class="col-sm-9 mb-2">
                            <b-form-select v-model="displayDate">
                              <b-form-select-option :value="null">{{ t('selectOptionText', 'selectOptionText') }}</b-form-select-option>
                              <b-form-select-option value="notRequired">{{ t('notRequiredText', 'notRequiredText') }}</b-form-select-option>
                              <b-form-select-option value="todaysDate">{{ t('todaysDateText', 'todaysDateText') }}</b-form-select-option>
                              <b-form-select-option value="specifiedDate">{{ t('sepcifiedDateText', 'sepcifiedDateText') }}</b-form-select-option>
                            </b-form-select>
                          </div>
                          <label for="specifiedDate" class="col-sm-3 col-form-label">{{ t('sepcifiedDateText', 'sepcifiedDateText') }}</label>
                          <div class="col-sm-9 mb-2">
                            <datePicker id="specifiedDate" v-model="specifiedDate" class="form-control" :config="datePickerConfig" :placeholder="'Specified Date'"></datePicker>
                            <!--<input type="text" class="form-control" id="specifiedDate" placeholder="Specified Date" v-model="specifiedDate">-->
                          </div>
                          <label for="displayAddress" class="col-sm-3 col-form-label">{{ t('displayAddressLabel', 'displayAddressLabel') }}</label>
                          <div class="col-sm-9 mb-2">
                            <b-form-checkbox id="displayAddress" name="displayAddress" value="1" unchecked-value="0" v-model="displayAddress"></b-form-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-5 element-box mt-0 ml-2">
                    <div class="col-12 form-group">
                      <div class="element-info pb-0">
                        <h5>{{ t('selectRecipientsText', 'selectRecipientsText') }}</h5>
                        <hr>
                        <div class="row form-group form-line">
                          <label for="audienceType" class="col-sm-3 col-form-label">{{ t('selectAudienceText', 'selectAudienceText') }}</label>
                          <div class="col-sm-9 mb-2">
                            <b-form-select v-model="audienceType">
                              <b-form-select-option :value="null">{{ t('selectOptionText', 'selectOptionText') }}</b-form-select-option>
                              <b-form-select-option value="none">{{ t('noneText', 'noneText') }}</b-form-select-option>
                              <b-form-select-option value="customList">{{ t('customListText', 'customListText') }}</b-form-select-option>
                              <b-form-select-option value="predefinedList">{{ t('predefinedListText', 'predefinedListText') }}</b-form-select-option>
                              <b-form-select-option value="all">{{ t('allText', 'allText') }}</b-form-select-option>
                            </b-form-select>
                          </div>
                          <template v-if="audienceType == 'customList'">
                            <label for="distributionCSV" class="col-sm-3 col-form-label">{{ t('provideDistributionListLabel', 'provideDistributionListLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <!-- <input type="file" class="form-control" id="distributionCSV"> -->
                              <b-form-file id="distributionCSV" v-model="distributionCSV"></b-form-file>
                            </div>
                            <label for="customerReference" class="col-sm-3 col-form-label">{{ t('customerReferenceText', 'customerReferenceText') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.customerReference" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customName" class="col-sm-3 col-form-label">{{ t('nameLabel', 'nameLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.name" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customEmail" class="col-sm-3 col-form-label">{{ t('emailAddressLabel', 'emailAddressLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.emailAddresss" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customFloorBuilding" class="col-sm-3 col-form-label">{{ t('floorBuildingNumberLabel', 'floorBuildingNumberLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.floorBuildingName" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customStreet" class="col-sm-3 col-form-label">{{ t('streetLabel', 'streetLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.street" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customSuburb" class="col-sm-3 col-form-label">{{ t('suburbLabel', 'suburbLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.suburb" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customCity" class="col-sm-3 col-form-label">{{ t('cityLabel', 'cityLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.city" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customPostcode" class="col-sm-3 col-form-label">{{ t('postCodeLabel', 'postCodeLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.postcode" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customCountry" class="col-sm-3 col-form-label">{{ t('countryLabel', 'countryLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.country" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customSelectedCountry" class="col-sm-3 col-form-label">{{ t('selectCountryLabel', 'selectCountryLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.selectedCountry">
                                <b-form-select-option :value="null">{{ t('selectOptionText', 'selectOptionText') }}</b-form-select-option>
                                <b-form-select-option value="none">{{ t('noneText', 'noneText') }}</b-form-select-option>
                                <b-form-select-option v-for="country in allCountries" :value="country.id" :key="country.id"> {{ country.name }}</b-form-select-option>
                              </b-form-select>
                            </div>
                            <label for="customOption1" class="col-sm-3 col-form-label">{{ t('customOption1Label', 'customOption1Label') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.custom1" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customOption2" class="col-sm-3 col-form-label">{{ t('customOption2Label', 'customOption2Label') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.custom2" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customOption3" class="col-sm-3 col-form-label">{{ t('customOption3Label', 'customOption3Label') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.custom3" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customOption4" class="col-sm-3 col-form-label">{{ t('customOption4Label', 'customOption4Label') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.custom4" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customOption5" class="col-sm-3 col-form-label">{{ t('customOption5Label', 'customOption5Label') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.custom5" :options="columnOptions"></b-form-select>
                            </div>
                            <label for="customOption6" class="col-sm-3 col-form-label">{{ t('customOption6Label', 'customOption6Label') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="customListData.custom6" :options="columnOptions"></b-form-select>
                            </div>
                          </template>
                          <template v-else-if="audienceType == 'predefinedList'">
                            <label for="predefinedCountry" class="col-sm-3 col-form-label">{{ t('selectCountryLabel', 'selectCountryLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <select class="form-control" v-model="predefinedListData.country" v-if="availableCountries" @change="getAffectedCustomers()">
                                <option value=""> N/A </option>
                                <option v-for="country in availableCountries" :value="country.id" :key="country.id"> {{ country.english }}</option>
                              </select>
                            </div>
                            <label for="predefinedLanguage" class="col-sm-3 col-form-label">{{ t('selectLanguageLabel', 'selectLanguageLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <select class="form-control" v-model="predefinedListData.language" v-if="availableLanguages" @change="getAffectedCustomers()">
                                <option value=""> N/A </option>
                                <option v-for="language in availableLanguages" :value="language.id" :key="language.id"> {{ language.name }}</option>
                              </select>
                            </div>
                            <label for="predefinedTimeframe" class="col-sm-3 col-form-label">{{ t('selectTimeframeLabel', 'selectTimeframeLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-select v-model="predefinedListData.timeframe" @change="getAffectedCustomers()">
                                <option value="">{{ t('notAvailableText', 'notAvailableText') }}</option>
                                <b-form-select-option value="3">{{ t('timeLapse3Months', 'timeLapse3Months') }}</b-form-select-option>
                                <b-form-select-option value="6">{{ t('timeLapse6Months', 'timeLapse6Months') }}</b-form-select-option>
                                <b-form-select-option value="12">{{ t('timeLapse12Months', 'timeLapse12Months') }}</b-form-select-option>
                              </b-form-select>
                              <div v-if="affectedCustomersCount || affectedCustomersCount == 0">
                                <small style="color: red;">{{ affectedCustomersCount }} {{ t('customersCountSelectedText', 'customersCountSelectedText') }}</small>
                              </div>
                            </div>
                          </template>
                          <template v-else-if="audienceType == 'all'">
                            <label for="sendToAllContacts" class="col-sm-3 col-form-label">{{ t('sendToAllContactsLabel', 'sendToAllContactsLabel') }}</label>
                            <div class="col-sm-9 mb-2">
                              <b-form-checkbox id="sendToAllContacts" name="sendToAllContacts" value="1" unchecked-value="" v-model="allListData.sendToAll"></b-form-checkbox>
                            </div>
                            <label v-if="allListData.sendToAll" for="sendToAllConfirmation" class="col-sm-3 col-form-label">{{ t('sendToAllContactsConfirmationLabel', 'sendToAllContactsConfirmationLabel') }}</label>
                            <div v-if="allListData.sendToAll" class="col-sm-9 mb-2">
                              <b-form-checkbox id="sendToAllConfirmation" name="sendToAllConfirmation" value="1" unchecked-value="0" v-model="allListData.sendToAllConfirmation"></b-form-checkbox>
                            </div>
                          </template>
                          <template v-if="audienceType && audienceType != 'none'">
                            <div class="col-sm-12 col-form-label">
                              <b-form-checkbox class="d-inline" id="isATestBatch" name="isATestBatch" value="1" unchecked-value="0" v-model="isTestBatch"></b-form-checkbox>
                              <span>{{ t('importDataIsTestBatchLabel', 'importDataIsTestBatchLabel') }}</span>
                            </div>
                            <div class="col-sm-12 mb-2">
                              <b-form-group class="mt-1">
                                <b-form-radio name="sendMethod" v-model="sendMethod" value="Simulate deliveries">{{ t('importDataSimulateDeliveriesLabel', 'importDataSimulateDeliveriesLabel') }}</b-form-radio>
                                <b-form-radio name="sendMethod" v-model="sendMethod" value="Divert deliveries">{{ t('importDataDiverDeliveriesToTesterLabel', 'importDataDiverDeliveriesToTesterLabel') }}</b-form-radio>
                              </b-form-group>
                            </div>
                            <ResponseInfo v-if="getResponseInfo.responseName == 'broadcastMessage'" class="mt-3"/>
                            <div class="col-12 text-right">
                              <!--<button class="btn btn-primary" :disabled="enableUpload">{{ t('uploadBtnText', 'uploadBtnText') }}</button>-->
                              <!-- NS-10021 Make the button change form while msg is being uploaded, PW -->
                              <button :disabled="enableUpload" v-if="!isUploading" class="btn btn-primary" type="submit" >{{ t('uploadBtnText','uploadBtnText') }}</button>
                              <b-button v-else variant="primary" disabled>
                                <b-spinner small type="grow"></b-spinner>
                                {{ t('uploadingBtnText','uploadingBtnText') }}
                              </b-button>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import ResponseInfo from '@/components/ResponseInfo.vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import datePicker from 'vue-bootstrap-datetimepicker'

export default {
  name: 'BroadcastMessage',
  data () {
    return {
      messagePDF: null,
      distributionCSV: null,
      displayDate: null,
      specifiedDate: null,
      emailSubject: '',
      emailText: '',
      displayAddress: 0,
      audienceType: null,
      selectedLanguage: null,
      selectedTimeframe: null,
      isTestBatch: 0,
      availableLanguages: null,
      availableCountries: null,
      allCountries: null,
      affectedCustomers: null,
      sendMethod: 'Simulate deliveries',
      // NS-10021 variable to decide if the request has finished processing
      isUploading: false,
      predefinedListData: {
        language: null,
        country: null,
        timeframe: null
      },
      allListData: {
        sendToAll: 0,
        sendToAllConfirmation: 0
      },
      customListData: {
        distributionList: null,
        customerReference: null,
        name: null,
        emailAddresss: null,
        floorBuildingName: null,
        street: null,
        suburb: null,
        city: null,
        postcode: null,
        country: null,
        selectedCountry: null,
        custom1: null,
        custom2: null,
        custom3: null,
        custom4: null,
        custom5: null,
        custom6: null
      },
      columnOptions: [
        { value: 0, text: 'Not Required'},
        { value: 1, text: 'Column A'},
        { value: 2, text: 'Column B'},
        { value: 3, text: 'Column C'},
        { value: 4, text: 'Column D'},
        { value: 5, text: 'Column E'},
        { value: 6, text: 'Column F'},
        { value: 7, text: 'Column G'},
        { value: 8, text: 'Column H'},
        { value: 9, text: 'Column I'},
        { value: 10, text: 'Column J'},
        { value: 11, text: 'Column K'},
        { value: 12, text: 'Column L'},
        { value: 13, text: 'Column M'},
        { value: 14, text: 'Column N'},
        { value: 15, text: 'Column O'},
        { value: 16, text: 'Column P'},
        { value: 17, text: 'Column Q'},
        { value: 18, text: 'Column R'},
        { value: 19, text: 'Column S'},
        { value: 20, text: 'Column T'},
        { value: 21, text: 'Column U'},
        { value: 22, text: 'Column V'},
        { value: 23, text: 'Column W'},
        { value: 24, text: 'Column X'},
        { value: 25, text: 'Column Y'},
        { value: 26, text: 'Column Z'}
      ],
      datePickerConfig: {
          icons: {
            time: 'os-icon os-icon-calendar-time',
            date: 'os-icon os-icon-basic-2-259-calendar',
            up: 'os-icon os-icon-chevron-up',
            down: 'os-icon os-icon-chevron-down',
            previous: 'os-icon os-icon-chevron-left',
            next: 'os-icon os-icon-chevron-right',
            clear: 'os-icon os-icon-trash',
            close: 'os-icon os-icon-cancel-circle'
          },
        minDate: moment('1979-01-01', this.datePickerFormat),
        showClear: true
      },
    }
  },
  methods: {
    broadcastMessage() {
      let formData = new FormData();
      formData.append('messagePDF', this.messagePDF)

      if(this.audienceType == 'predefinedList') {
        var data = this.predefinedListData
        data.audienceType = 'predefined'
      } else if (this.audienceType == 'customList') {
        var data = this.customListData
        data.audienceType = 'custom'

        formData.append('distributionCSV', this.distributionCSV)
      } else if (this.audienceType == 'all') {
        var data = this.allListData
        data.audienceType = 'all'
      }

      data.displayDate = this.displayDate
      data.specifiedDate = this.specifiedDate
      data.emailSubject = this.emailSubject
      data.emailText = this.emailText
      data.displayAddress = this.displayAddress
      data.isTestBatch = this.isTestBatch
      data.sendMethod = this.sendMethod

      for ( var key in data ) {
          formData.append(key, data[key]);
      }

      if(this.audienceType) {
        // NS-10021 variable to check if the request has finished processing
        this.isUploading = true
        this.$store.dispatch('broadcastMessageStore/sendBroadcastMessage', formData).then(() => {
          this.isUploading = false
        })
      }
    },


    getBroadcastOptions() {
      this.$store.dispatch('broadcastMessageStore/getBroadcastOptions').then(response => {
        if(response.languages) {
          this.availableLanguages = response.languages
        }

        if(response.countries) {
          this.availableCountries = response.countries
        }

        if(response.allCountries) {
          this.allCountries = response.allCountries
        }

        if(response.isTesterUser) {
          this.isTestBatch = 1
        }

        // NS-9997 Added default values for broadcast msg, PW
        if(response.defaultValues) {
          let defValues = response.defaultValues
          this.customListData.customerReference = 1
          this.customListData.name = 2
          this.customListData.street = 3
          this.customListData.city = 4
          this.customListData.postcode = 5
        }
      })
    },

    getAffectedCustomers() {
      this.$store.dispatch('broadcastMessageStore/getAffectedCustomers', {
        countryId: this.predefinedListData.country,
        languageId: this.predefinedListData.language,
        timeframe: this.predefinedListData.timeframe
      }).then(response => {
        this.affectedCustomers = response.affectedCustomers
      })
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    
    affectedCustomersCount() {
      if(this.affectedCustomers || this.affectedCustomers == 0) {
        return Object.keys(this.affectedCustomers).length
      } else {
        return null
      }
    },

    enableUpload() {
      if(this.messagePDF) {
        if(this.audienceType) {
          if(this.audienceType == 'all' && this.allListData.sendToAllConfirmation != 0) {
            return false
          } else if(this.audienceType == 'customList' && this.distributionCSV && this.customListData.customerReference) {
            return false
          } else if(this.audienceType == 'predefinedList' && (this.predefinedListData.language || this.predefinedListData.country || this.predefinedListData.timeframe)) {
            return false
          }
        }
      }

      return true
    },

    datePickerFormat() {
      if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
          let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
          return dateformat
        } else {
          return "DD-MM-YYYY"
      }
    }
  },
  watch: {
    
  },
  created() {
    this.datePickerConfig.format = this.datePickerFormat

    let todaysDate = moment(new Date(), this.datePickerFormat)
    this.datePickerConfig.maxDate = todaysDate
    this.getBroadcastOptions()
  },
  filters:{

  },
  components:{
    Navbar,
    ResponseInfo,
    datePicker
  }
}
</script>
<style scoped>
  .text-netsend-blue{
    color: #047bf8;
  }
  .showhand{
    cursor: pointer;
  }
  .log-search-border{
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px;
    border-radius: 10px;
  }
  #logToggle{
    font-size: 1.2rem;
    font-weight: bold;
    display:inline-block;
    -moz-transition: all .5s linear;
    -webkit-transition: all .5s linear;
    transition: all .5s linear;
  }
  #logToggle.collapsed{
    -moz-transform:rotate(180deg);
    -webkit-transform:rotate(1800deg);
    transform:rotate(180deg);
  }
  .log-search div:first-child.input-group{
    margin-left: 10px;
  }
  fieldset >>> legend::before{
    background-color: transparent;
  }
  fieldset >>> legend{
    color: #3E4B5B;
  }
  .modal-lg >>> .modal-header{
    background-color: #737475;
  }
  .modal-body-log div:nth-child(2n){
    background-color: #f7f9fa;
    border-top: 1px solid rgba(83, 101, 140, 0.33);
    border-bottom: 1px solid rgba(83, 101, 140, 0.33);
  }
  .busy-row{
    display: contents;
  }
  .spinner-row{
    min-height: 150px;
  }
  .table-records-info{
    display: flex;
    align-items: center;
  }
  table >>> tbody, table >>> thead{
    text-align: center;
  }
  .table-responsive  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
  .element-wrapper {
    padding-bottom: 0px;
  }
  .content-box {
    padding-bottom: 0px;
  }
</style>
